import { render } from "./CountryDashboardsFilterBlock.vue?vue&type=template&id=58a4634e&ts=true"
import script from "./CountryDashboardsFilterBlock.vue?vue&type=script&lang=ts"
export * from "./CountryDashboardsFilterBlock.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__